import React, { forwardRef } from "react";
import classNames from "classnames";
import IBuildrProps from "src/utilities/IBuildrProps";
import "./textcolumns.style.scss";

export interface ITextColumnsProps extends IBuildrProps {
    columns: 1 | 2 | 3;
    title: string;
    children: string;
}

export default forwardRef((props: ITextColumnsProps, ref: any) => {
    return (
        <div ref={ref} data-id={props.cmsId} className={classNames("pt-4 pb-4 text-columns", props.className, props.editorClassObj)}>
            <div className="row">
                <div className="col text-center text-primary">
                    <h2>{props.title}</h2>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className={`columns p-3 columns-${props.columns}`}>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
});
